import React from "react";
import { useSelector } from "react-redux";

export const AllowAccess = ({ allowedRights, children }) => {
  const userRights = useSelector((state) => state.rights);

  const userHasAccess = allowedRights?.some((value) => userRights?.includes(value));
  return <>{userHasAccess ? children : null}</>;
};
